import { apiClient } from '@utils';

export const useRoles = () => {
  const result = apiClient.roles.getRoles.useQuery(['roles-list'], {});
  return { ...result, data: result.data?.body };
};
